import { actions } from '@app/action/invitation';

export default function(state = {}, action) {
  const { type } = action;

  switch (type) {
    case actions.GET_INVITATIONS:
      return {
        ...state,
        list: action.invitations || [],
      };

    case actions.INVITE_TO_TEAM_SUCCESS: {
      const newInvitations = state.list;
      newInvitations.push(action.invitee);

      return {
        ...state,
        list: newInvitations,
      };
    }

    case actions.GET_INVITATION:
      return {
        ...state,
        current: action.invitation,
      };

    case actions.DELETE_INVITATION_SUCCESS: {
      const newInvitations = state.list;

      return {
        ...state,
        list: newInvitations.filter(
          (invitation) => invitation.id !== action.invitation.id
        ),
      };
    }

    case actions.UPDATE_INVITATION_SUCCESS: {
      return {
        ...state,
      };
    }
  }

  return state;
}
